var _circle, _g, _mask, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#ffd5d2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#error_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 19,
    fill: "#fff"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "error_svg__b",
    width: 24,
    height: 24,
    x: 14,
    y: 14,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M14 14h24v24H14z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#error_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed1c24",
    d: "M26 35.4q-.352 0-.681-.138a2 2 0 0 1-.6-.389l-7.592-7.592a2 2 0 0 1-.389-.6 1.7 1.7 0 0 1-.138-.68 1.8 1.8 0 0 1 .136-.689 1.8 1.8 0 0 1 .392-.592l7.592-7.592q.271-.275.6-.401c.329-.126.446-.126.681-.126a1.9 1.9 0 0 1 .688.128q.337.127.592.399l7.592 7.592a1.6 1.6 0 0 1 .399.59 1.92 1.92 0 0 1 .002 1.371 1.7 1.7 0 0 1-.401.6l-7.592 7.592q-.256.255-.59.392c-.334.137-.453.136-.691.136zm.221-1.596 7.583-7.583q.077-.077.077-.221c0-.144-.026-.17-.077-.221l-7.583-7.582q-.077-.077-.221-.077c-.144 0-.17.026-.221.077l-7.582 7.583q-.077.077-.077.221c0 .144.026.17.077.221l7.583 7.583q.077.077.221.077c.144 0 .17-.026.221-.077zM26 27.087q.32 0 .534-.216c.214-.216.216-.322.216-.534v-4.115q0-.319-.216-.534c-.216-.215-.322-.216-.534-.216s-.391.072-.534.216-.215.322-.215.534v4.115q0 .319.216.534c.216.215.322.216.535.216zm0 2.616a.78.78 0 0 0 .808-.808.78.78 0 0 0-.808-.808.78.78 0 0 0-.808.808.78.78 0 0 0 .808.808"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "error_svg__a",
    width: 52,
    height: 52,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "A"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "B",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "B",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "A"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic"
  })))));
};
export default SvgError;